import { createApp, setup } from '@shared/setup'

import Router from '@shared/modules/COffer/Router'
import COfferRoot from '@shared/modules/COffer/components/COfferRoot'

import { APP } from '@shared/config/constants'

window._appName = APP.COFFER.name
window._appGroup = APP.COFFER.group
const element = document.getElementById('cOffer')

const props = element.dataset

const app = await setup({
  appInstance: createApp(COfferRoot, props),
  appName: window._appName,
})
app.use(Router)
app.mount(element)
